module.exports = __webpack_public_path__ + "static/media/mx.2728f57a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/mx.svg
// module id = 90
// module chunks = 0